module.exports = __webpack_public_path__ + "img/toplupe-pubgm.0a93c40.png";